import snapshotService from "@/services/mrfiktiv/services/snapshotService";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class SnapshotFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.SNAPSHOT;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.SNAPSHOT, async () => {
      return await snapshotService.getDocumentBySharedAccessToken(partnerId, refId, sct);
    });
  }
}
